"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./AnagraficaApi"), exports);
__exportStar(require("./AuthenticationApi"), exports);
__exportStar(require("./CertificazioneApi"), exports);
__exportStar(require("./CertificazioneCellulareApi"), exports);
__exportStar(require("./CertificazioneEmailApi"), exports);
__exportStar(require("./DashboardApi"), exports);
__exportStar(require("./LogApi"), exports);
__exportStar(require("./LottoApi"), exports);
__exportStar(require("./ReportApi"), exports);
__exportStar(require("./TestApi"), exports);
